import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sciensano_logo_white.svg")